import { useEffect } from 'react';

import { CompanyFormFields, CoveredLivesCount, InfoFormFields } from '@/components/pages/Teams/types';

export const TEAMS_USER_INFO_KEY = 'teams-user-info';

export const useStoreSsCheckoutProgress = (
	didInitializePage: boolean,
	infoPageFields: InfoFormFields | undefined,
	companyPageFields: CompanyFormFields | undefined,
	coveredLivesVal: CoveredLivesCount | undefined,
): void => {
	useEffect(() => {
		if (didInitializePage) {
			const teamsUserInfo = {
				firstName: infoPageFields?.firstName,
				lastName: infoPageFields?.lastName,
				workEmail: infoPageFields?.email,
				company: companyPageFields?.companyName,
				companySize: companyPageFields?.companySize,
				jobTitle: companyPageFields?.role,
				coveredLives: coveredLivesVal,
			};
			sessionStorage.setItem(TEAMS_USER_INFO_KEY, JSON.stringify(teamsUserInfo));
		}
	}, [coveredLivesVal, infoPageFields, companyPageFields, didInitializePage]);
};
